import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import OnlineOrderFormProps from "../../services/models/formModels/OnlineOrderForm.model";

function SecurityInfoFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  getFieldMeta,
  setFieldValue,
  submission,
  disabled,
}: OnlineOrderFormProps): JSX.Element {
  const fieldsToUse = submission
    ? dataConstants?.securityInfoSubmissionFields
    : dataConstants?.securityInfoFields;
  return (
    <FieldRenderer
      fields={fieldsToUse.map((field, index) => {
        return {
          key: `${index}${field.labelInfo?.inputId}`,
          ...field,
          values,
          getFieldMeta,
          errors: errors,
          touched: touched,
          onChange: handleChange,
          disabled: disabled,
          value: values?.[!!field?.name ? field.name : ""],
          onBlur: handleBlur,
          name: field.name,
          roundedInput: true,
          // "data-openreplay-obscured": true,
          "data-dd-privacy": "mask",
          parentContainerClass: [
            "securityInfo.ssn",
            "securityInfo.mrn",
          ].includes?.(field?.name ? field.name : "")
            ? "md:!w-[48%] mx-1"
            : "",
        };
      })}
    />
  );
}

export default SecurityInfoFields;
